import { render, staticRenderFns } from "./AddClientContactComponent.vue?vue&type=template&id=0ffe0318&scoped=true&"
import script from "./AddClientContactComponent.vue?vue&type=script&lang=ts&"
export * from "./AddClientContactComponent.vue?vue&type=script&lang=ts&"
import style0 from "./AddClientContactComponent.vue?vue&type=style&index=0&id=0ffe0318&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ffe0318",
  null
  
)

export default component.exports